module.exports = __webpack_public_path__ + "img/background-mobile-bottom.79db6d39.svg";